import { Box, CircularProgress } from "@mui/material";

export const AppLoader = () => {
  return (
    <Box
      sx={{ height: "100vh" }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      justifyItems="center"
    >
      <CircularProgress size={50} />
    </Box>
  );
};
